import React, { useEffect } from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDStack } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { navigateByRelationship } from 'Views/Page/Content/Templates';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useLayoutContext } from 'Context/LayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import {
  RoadmapDeliverableWrapperLayout,
} from '../Wrapper/RoadmapDeliverableWrapperLayout';
import PlannerInsightChatMetaOverrideSet from '../PlannerInsightChat/metaOverrideSet';
import { PlannerInsightChatLayout } from '../PlannerInsightChat/layout';
import { Content } from './Content';

const RoadmapDeliverableLayout = () => {
  const { resource } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();
  useBoneBackgroundColor();
  const { setNavigationVisible } = useLayoutContext();

  useEffect(() => {
    setNavigationVisible(false);
  }, [setNavigationVisible]);

  if (!resource) {
    return null;
  }

  const PlannerInsightChat = (
    <MetaResourceRenderer
      resource={resource} // has attrs for cfp insight
      layout={PlannerInsightChatLayout}
      metaOverrideSet={PlannerInsightChatMetaOverrideSet}
    />
  );

  const handlePreviousOverride = resource.withRelationship(fr.relationships.details.name,
    (rel) => async () => {
      await navigateByRelationship(rel, loadModalCollectionByLink, loadPageContentLink, clearModalCollection);
    },
    () => null);

  return (
    <RoadmapDeliverableWrapperLayout handlePreviousOverride={handlePreviousOverride} {...dataAttrs(`${resource.type()}-layout`)}>
      <FDStack direction="column" spacing={2} width={'100%'} maxWidth={600}>
        {PlannerInsightChat}
        <Content />
      </FDStack>
    </RoadmapDeliverableWrapperLayout>
  );
};

export default RoadmapDeliverableLayout;
